<script lang="ts">
import { AppVivitionComponent } from "./app-vivition.ts";
export default AppVivitionComponent;
</script>
<template>
    <div class="vivion-container" ref="container">
        <!-- <div class="playercontainer vivition-setfullscreen" v-html="playerMarkup_"></div> -->
        <!-- <div v-if="playerThumbMarkup_" v-html="playerThumbMarkup_"></div> -->
        <div
            className="vivition-player"
            style="
                 {
                    background: `url(https://static-api.vivition.com/carconnex_website/licenceplate_vin/_${vin}/initialphoto.jpg) no-repeat center / cover`;
                }
            "
            data-licenceplate=""
            :data-vin="vin"
            data-theme="carconnex_website"
        />
    </div>
</template>

<style lang="scss">
@import "../../../shared/styles/mixins";
.vivion-container {
    width: 100%;
    height: c-rem(520);
    margin: c-rem(20) 0;
}
.vivition-thumbbar {
    height: c-rem(70);
}
</style>
